module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-modern_v2-dcd7494444ecdd684757c4222fd79e69.pdf";